import styled from 'styled-components';

const GroupReportStyle = styled.div`
    .user-title-container{
        text-align: left;
    }
    .user-menu-title{
        font-size: 1.424rem;
        font-weight: 700;
        line-height: 1.3;
        margin: 0px;
        word-break: break-word;
        hyphens: auto;
        text-align: left;
        margin-bottom: 10px;
    }    
    .course-overview-data-box{
        display: flex;
        justify-content: space-around;
        padding: 16px 0px;
        background: rgb(245, 245, 246);
    }
    .overview-value{
        font-size: 1.802rem;
        font-weight: 700;
        line-height: 1.3;
        margin: 0px;
    }

    .overview-label{
        font-size: 0.889rem;
        font-weight: 400;
        line-height: 1.3;
        margin: 0px;
    }

    .yet-designed-pages{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .yet-designed-pages-image{
        width: 40%;
    }
    .developement-content{
        font-size: 1.266rem;
        line-height: 1;
        color: rgb(0, 0, 0);
        margin-bottom: 1rem;
    }
`;

export default GroupReportStyle;